import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { School, Nature, EmojiEvents, Group } from '@mui/icons-material';

const QuickLinks = () => {
    const links = [
        { text: 'How It Works', path: '/how-it-works', icon: <School /> },
        { text: 'Features', path: '/features', icon: <Nature /> },
        { text: 'Leaderboard', path: '/leaderboard', icon: <EmojiEvents /> },
        { text: 'About Us', path: '/about', icon: <Group /> }
    ];

    return (
        <Box>
            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: '#66bb6a' }}>
                🚀 Explore
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
                {links.map((item) => (
                    <Box component="li" key={item.text} sx={{ py: 0.8 }}>
                        <MuiLink
                            component={Link}
                            to={item.path}
                            sx={{
                                color: 'rgba(255,255,255,0.8)',
                                textDecoration: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '0.95rem',
                                '&:hover': {
                                    color: '#66bb6a',
                                    transform: 'translateX(4px)'
                                },
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <Box sx={{ mr: 1, fontSize: '1.2rem' }}>{item.icon}</Box>
                            {item.text}
                        </MuiLink>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default QuickLinks;
